import React, { useState } from "react";
import { Form, Modal, Input, Button, message } from "antd";
import { Row, Col } from "react-bootstrap";
import { API, Headers } from "../../../../Config";
import axios from "axios";
import styles from "../../styles";

const { TextArea } = Input;
function FormAddAgentModal(props) {
  const [loading, setLoading] = useState(false);
  const onFinish = (values) => {
    setLoading(true);
    let requestObj = {
      name: values.name,
      code: values.code,
      account_number: parseInt(values.account_number),
    };

    const RowID = props.selected && props.selected[0]?.id;

    let URL =
      props.mode === "post"
        ? API.BASR_URL + API.ISSUING_CARRY_AGENT_ACTIONS
        : API.BASR_URL + API.ISSUING_CARRY_AGENT_ACTIONS + RowID;

    axios({
      method: props.mode,
      url: URL,
      headers: Headers(),
      data: requestObj,
    })
      .then(function (response) {
        if ([200, 201].includes(response.status)) {
          message.success("Success");
          props.reload();
        }
      })
      .catch(function (error) {
        message.error("Oops.Something went wrong");
        console.log(error);
      });
    setLoading(false);
  };

  return (
    <Modal visible={props.visible} onCancel={props.onClose} footer={false}>
      <h5 className="PrintLabelModal-txt1">
        {props.mode === "post" ? "Add" : "Modify"}
        {"  "}
        Contact
      </h5>
      <br />
      <Form
        initialValues={{
          name: props.selected && props.selected[0]?.name,
          code: props.selected && props.selected[0]?.code,
          account_number: props.selected && props.selected[0]?.account_number,
        }}
        onFinish={onFinish}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          name="account_number"
          label="Account Number"
          style={{ margin: 4 }}
        >
          <Input />
        </Form.Item>
        <Form.Item name="code" label="IATA CODE" style={{ margin: 4 }}>
          <Input placeholder="" style={styles.FormInput} />
        </Form.Item>
        <Form.Item name="name" label="Display Name" style={{ margin: 4 }}>
          <Input placeholder="" style={styles.FormInput} />
        </Form.Item>
        <br />
        <Row>
          <Col sm="6"></Col>
          <Col sm="3">
            <Button type="primary" htmlType="submit" block>
              Add
            </Button>
          </Col>
          <Col sm="3">
            <Button onClick={props.onClose} block>
              Cancel
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default FormAddAgentModal;
